import React, { FC } from 'react';

import styled from '@tanium/react-emotion-9';
import { Pill } from '@tanium/react-pill';
import { css } from '@tanium/style-system';
import { ThemeSpace } from '@tanium/theme-data';

import { UseAdvancedFiltersReturnValue } from '../hooks/useAdvancedFilters';

interface PillsProps
  extends Pick<UseAdvancedFiltersReturnValue, 'pills' | 'value' | 'updateFilter'> {}

const PillsContainer = styled('div')(
  css({
    alignItems: 'center',
    display: 'flex',
    flexGrow: 1,
    flexWrap: 'wrap',
  }),
);

const PillWrapper = styled('div')(
  css({
    p: ThemeSpace.minor[1],
    pl: 0,
  }),
);

const FilterPills: FC<PillsProps> = React.memo(({ pills, value, updateFilter }) => (
  <PillsContainer>
    {pills.map((dataKey) => {
      const field = value[dataKey];
      const { label, displayValue } = field.pill;
      return (
        <PillWrapper key={dataKey}>
          <Pill
            keyForValue={field.pill.label}
            onRemove={() => {
              updateFilter({ dataKey, label, displayValue, value: undefined });
            }}
          >
            {field.pill.displayValue}
          </Pill>
        </PillWrapper>
      );
    })}
  </PillsContainer>
));

export default FilterPills;
